var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6579 3.22012C10.7988 3.3611 10.878 3.55229 10.878 3.75163C10.878 3.95098 10.7988 4.14217 10.6579 4.28315L6.9365 8.00454L10.6579 11.7259C10.7948 11.8677 10.8706 12.0576 10.8689 12.2547C10.8672 12.4519 10.7881 12.6404 10.6487 12.7798C10.5093 12.9192 10.3208 12.9983 10.1237 13C9.92654 13.0017 9.73664 12.9259 9.59485 12.789L5.34194 8.53606C5.201 8.39508 5.12183 8.20389 5.12183 8.00454C5.12183 7.80519 5.201 7.614 5.34194 7.47302L9.59485 3.22012C9.73583 3.07918 9.92702 3 10.1264 3C10.3257 3 10.5169 3.07918 10.6579 3.22012Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.1702277685f92d02bf16e993ada26a3a.svg";
export { ForwardRef as ReactComponent };